import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

import {
  Component,
  Directive,
  HostBinding,
  ViewEncapsulation,
  booleanAttribute,
  effect,
  inject,
  input,
  output,
  ChangeDetectionStrategy
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { map } from 'rxjs';

@Directive({

  host: { class: 'glxy-navigation-toolbar-left' },
  selector: '[glxyNavigationToolbarLeft], glxy-navigation-toolbar-left',
})
export class TooolbarLeftDirective {}

@Directive({

  host: { class: 'glxy-navigation-toolbar-right' },
  selector: '[glxyNavigationToolbarRight], glxy-navigation-toolbar-right',
})
export class ToolbarRightDirective {}

@Component({
  selector: 'glxy-navigation-toolbar',
  imports: [MatToolbarModule, MatButtonModule, MatIconModule],
  templateUrl: './navigation-toolbar.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './navigation-toolbar.component.scss',
})
export class NavigationToolbarComponent {
  @HostBinding('class') class = 'glxy-navigation-toolbar';
  @HostBinding('class.glxy-navigation-toolbar-is-mobile') mobileClass = false;

  private readonly isMobile = toSignal(
    inject(BreakpointObserver)
      .observe(Breakpoints.Handset)
      .pipe(map((result) => result.matches)),
    { initialValue: false },
  );

  menuToggleClicked = output();
  hideMenuToggle = input(false, { transform: booleanAttribute });

  constructor() {
    effect(() => {
      this.mobileClass = this.isMobile() || false;
    });
  }

  toggleMenu() {
    this.menuToggleClicked.emit();
  }
}
